import * as Types from '../../../@graphql/types'

import {gql} from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type StoriesIncutBlockByIdQueryVariables = Types.Exact<{
  Id: Types.Scalars['UUID']
}>

export type StoriesIncutBlockByIdQuery = {__typename?: 'Query'} & {
  storiesIncutBlockById?: Types.Maybe<{__typename?: 'StoriesIncutBlock'} & StoriesIncutBlockByIdFragmentFragment>
}

export type SaveStoriesIncutBlockByIdMutationVariables = Types.Exact<{
  data: Types.SaveStoriesIncutBlockInput
}>

export type SaveStoriesIncutBlockByIdMutation = {__typename?: 'Mutation'} & {
  saveStoriesIncutBlock?: Types.Maybe<
    {__typename?: 'SaveStoriesIncutBlockPayload'} & {
      block?: Types.Maybe<{__typename?: 'StoriesIncutBlock'} & StoriesIncutBlockByIdFragmentFragment>
    }
  >
}

export type StoriesIncutBlockByIdFragmentFragment = {__typename?: 'StoriesIncutBlock'} & Pick<
  Types.StoriesIncutBlock,
  'uid' | 'position' | 'title' | 'incutType' | 'url' | 'clickCount'
> & {
    figureVersion?: Types.Maybe<
      {__typename?: 'FigureVersion'} & Pick<Types.FigureVersion, 'id'> & {
          figure: {__typename?: 'Figure'} & Pick<Types.Figure, 'id' | 'uid' | 'src'> & {
              cropperPreview: {__typename?: 'Image'} & Pick<Types.Image, 'url'>
            }
          crop: {__typename?: 'Crop'} & Pick<Types.Crop, 'height' | 'left' | 'top' | 'width'>
          primaryProcessedImage?: Types.Maybe<{__typename?: 'Image'} & Pick<Types.Image, 'url'>>
        }
    >
  }

export const StoriesIncutBlockByIdFragmentFragmentDoc = gql`
  fragment StoriesIncutBlockByIdFragment on StoriesIncutBlock {
    uid
    position
    title
    incutType
    url
    clickCount
    figureVersion {
      figure {
        id
        uid
        cropperPreview {
          url
        }
        src
      }
      id
      crop {
        height
        left
        top
        width
      }
      primaryProcessedImage {
        url
      }
    }
  }
`
export const StoriesIncutBlockByIdDocument = gql`
  query storiesIncutBlockById($Id: UUID!) {
    storiesIncutBlockById(Id: $Id) {
      ...StoriesIncutBlockByIdFragment
    }
  }
  ${StoriesIncutBlockByIdFragmentFragmentDoc}
`

/**
 * __useStoriesIncutBlockByIdQuery__
 *
 * To run a query within a React component, call `useStoriesIncutBlockByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoriesIncutBlockByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoriesIncutBlockByIdQuery({
 *   variables: {
 *      Id: // value for 'Id'
 *   },
 * });
 */
export function useStoriesIncutBlockByIdQuery(
  baseOptions: Apollo.QueryHookOptions<StoriesIncutBlockByIdQuery, StoriesIncutBlockByIdQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<StoriesIncutBlockByIdQuery, StoriesIncutBlockByIdQueryVariables>(
    StoriesIncutBlockByIdDocument,
    options
  )
}
export function useStoriesIncutBlockByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<StoriesIncutBlockByIdQuery, StoriesIncutBlockByIdQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<StoriesIncutBlockByIdQuery, StoriesIncutBlockByIdQueryVariables>(
    StoriesIncutBlockByIdDocument,
    options
  )
}
export type StoriesIncutBlockByIdQueryHookResult = ReturnType<typeof useStoriesIncutBlockByIdQuery>
export type StoriesIncutBlockByIdLazyQueryHookResult = ReturnType<typeof useStoriesIncutBlockByIdLazyQuery>
export type StoriesIncutBlockByIdQueryResult = Apollo.QueryResult<
  StoriesIncutBlockByIdQuery,
  StoriesIncutBlockByIdQueryVariables
>
export const SaveStoriesIncutBlockByIdDocument = gql`
  mutation saveStoriesIncutBlockById($data: SaveStoriesIncutBlockInput!) {
    saveStoriesIncutBlock(data: $data) {
      block {
        ...StoriesIncutBlockByIdFragment
      }
    }
  }
  ${StoriesIncutBlockByIdFragmentFragmentDoc}
`
export type SaveStoriesIncutBlockByIdMutationFn = Apollo.MutationFunction<
  SaveStoriesIncutBlockByIdMutation,
  SaveStoriesIncutBlockByIdMutationVariables
>

/**
 * __useSaveStoriesIncutBlockByIdMutation__
 *
 * To run a mutation, you first call `useSaveStoriesIncutBlockByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveStoriesIncutBlockByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveStoriesIncutBlockByIdMutation, { data, loading, error }] = useSaveStoriesIncutBlockByIdMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaveStoriesIncutBlockByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveStoriesIncutBlockByIdMutation,
    SaveStoriesIncutBlockByIdMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<SaveStoriesIncutBlockByIdMutation, SaveStoriesIncutBlockByIdMutationVariables>(
    SaveStoriesIncutBlockByIdDocument,
    options
  )
}
export type SaveStoriesIncutBlockByIdMutationHookResult = ReturnType<typeof useSaveStoriesIncutBlockByIdMutation>
export type SaveStoriesIncutBlockByIdMutationResult = Apollo.MutationResult<SaveStoriesIncutBlockByIdMutation>
export type SaveStoriesIncutBlockByIdMutationOptions = Apollo.BaseMutationOptions<
  SaveStoriesIncutBlockByIdMutation,
  SaveStoriesIncutBlockByIdMutationVariables
>
